/* eslint-disable react/forbid-prop-types */
// Shared per-channel result summary ("Email queued to jane@x.com", "WhatsApp
// failed: ...") — extracted from CreateSendPaymentLinkDialog.jsx so the ad-hoc
// "Create payment link" page's result card renders the exact same states.
import PropTypes from 'prop-types';
import { Stack, Typography } from '@mui/material';
import Iconify from 'src/components/Iconify';
import Label from 'src/components/Label';
import { describeChannelState } from './paymentLinkApi';

export const CHANNEL_STATE_COLOR = {
    not_requested: 'default',
    blocked: 'error',
    failed: 'error',
    queued: 'info',
    accepted: 'info',
    sent: 'success',
    delivered: 'success',
    read: 'success',
};

export default function PaymentLinkResultSummary({ result }) {
    return (
        <Stack spacing={1.5}>
            {['email', 'whatsapp'].map((channel) => {
                const channelResult = result?.channels?.[channel];
                if (!channelResult || channelResult.state === 'not_requested') return null;
                const { label, isOtherChannelBlock } = describeChannelState(channelResult);
                return (
                    <Stack key={channel} direction="row" spacing={1} alignItems="center">
                        <Iconify icon={channel === 'email' ? 'eva:email-fill' : 'mdi:whatsapp'} width={16} />
                        <Typography variant="body2" sx={{ textTransform: 'capitalize', minWidth: 80 }}>
                            {channel}
                        </Typography>
                        <Label
                            color={isOtherChannelBlock ? 'default' : (CHANNEL_STATE_COLOR[channelResult.state] || 'default')}
                            variant="ghost"
                        >
                            {label}
                        </Label>
                        {!isOtherChannelBlock && channelResult.error && (
                            <Typography variant="caption" color="error">
                                {channelResult.error}
                            </Typography>
                        )}
                    </Stack>
                );
            })}
        </Stack>
    );
}

PaymentLinkResultSummary.propTypes = {
    result: PropTypes.object,
};

PaymentLinkResultSummary.defaultProps = {
    result: null,
};
